import React, { useEffect, useState } from "react";
import PropTypes from "prop-types";
import api from "../../services/api";
import { FlashMessage } from "../assets/utils";

const selectClass = "w-full px-3 py-2 bg-warm-50 border border-warm-200 rounded-lg text-warm-800 text-sm focus:outline-none focus:ring-2 focus:ring-warm-300 transition";
const labelClass = "block text-xs font-semibold text-warm-500 uppercase tracking-wide mb-1.5";

const Preferences = ({ userPreferences, indexPreferences, defaultLanguages, handleUserIndexPreference, handleUserLanguage }) => {
    const [selectedPreference, setSelectedPreference] = useState("");
    const [selectedLanguage, setSelectedLanguage] = useState("");
    const [flashMessage, setFlashMessage] = useState(null);

    const handleSelectedPreference = (event) => {
        const val = parseInt(event.target.value);
        api.post('/updateIndexPreference', { index_preference_id: val })
            .then(() => {
                setSelectedPreference(val);
                handleUserIndexPreference(val);
                setFlashMessage('Preference updated');
            })
            .catch((error) => setFlashMessage(error.response?.data?.message ?? 'Error'));
    };

    const handleSelectedLanguage = (event) => {
        const val = parseInt(event.target.value);
        api.post('/updateLanguage', { default_language_id: val })
            .then(() => {
                setSelectedLanguage(val);
                handleUserLanguage(val);
                setFlashMessage('Language updated');
            })
            .catch((error) => setFlashMessage(error.response?.data?.message ?? 'Error'));
    };

    useEffect(() => {
        const match = indexPreferences.find(p => p.id === userPreferences.index_preference_id);
        if (match) setSelectedPreference(match.id);
    }, [indexPreferences, userPreferences.index_preference_id]);

    useEffect(() => {
        const match = defaultLanguages.find(l => l.id === userPreferences.default_language_id);
        if (match) setSelectedLanguage(match.id);
    }, [defaultLanguages, userPreferences.default_language_id]);

    return (
        <div className="bg-white rounded-2xl border border-warm-200 shadow-sm p-6">
            {flashMessage && (
                <FlashMessage message={flashMessage} duration={2000} onClose={() => setFlashMessage(null)} />
            )}
            <h2 className="font-serif text-lg font-semibold text-warm-800 mb-5">Preferences</h2>

            <div className="space-y-5">
                <div>
                    <label htmlFor="indexPreferences" className={labelClass}>Library view</label>
                    <select
                        id="indexPreferences"
                        name="index_preference_id"
                        className={selectClass}
                        onChange={handleSelectedPreference}
                        value={selectedPreference}
                    >
                        {indexPreferences.map((preference) => (
                            <option value={preference.id} key={preference.id}>{preference.name}</option>
                        ))}
                    </select>
                </div>

                <div>
                    <label htmlFor="language" className={labelClass}>Search language</label>
                    <select
                        id="language"
                        name="language"
                        className={selectClass}
                        onChange={handleSelectedLanguage}
                        value={selectedLanguage}
                    >
                        {defaultLanguages.map((language) => (
                            <option value={language.id} key={language.id}>{language.language}</option>
                        ))}
                    </select>
                </div>
            </div>
        </div>
    );
};

Preferences.propTypes = {
    userPreferences: PropTypes.shape({
        index_preference_id: PropTypes.number.isRequired,
        default_language_id: PropTypes.number.isRequired,
    }).isRequired,
    indexPreferences: PropTypes.arrayOf(PropTypes.shape({ id: PropTypes.number.isRequired, name: PropTypes.string.isRequired })).isRequired,
    defaultLanguages: PropTypes.arrayOf(PropTypes.shape({ id: PropTypes.number.isRequired, language: PropTypes.string.isRequired })).isRequired,
};

export default Preferences;
